import React from 'react';
import { FiSun, FiMoon } from 'react-icons/fi';
import { useDarkMode } from '../contexts/DarkModeContext';
import './DarkModeToggle.css';

const DarkModeToggle = ({ className = '' }) => {
  const { isDarkMode, toggleDarkMode } = useDarkMode();

  return (
    <button
      onClick={toggleDarkMode}
      className={`dark-mode-toggle ${className}`}
      title={`Switch to ${isDarkMode ? 'light' : 'dark'} mode`}
      aria-label={`Switch to ${isDarkMode ? 'light' : 'dark'} mode`}
    >
      <div className="toggle-icon-container">
        {isDarkMode ? (
          <FiSun size={16} className="toggle-icon" />
        ) : (
          <FiMoon size={16} className="toggle-icon" />
        )}
      </div>
    </button>
  );
};

export default DarkModeToggle;
